import Translatable from '../shared/interfaces/Translatable'
import LockerTypeTranslation from './LockerTypeTranslation'
import LockerTypeJson from 'src/models/locker/interfaces/LockerTypeJson'
import { Locales } from 'src/i18n'

export default class LockerType implements Translatable {
  id: string
  translations: { [locale: string]: LockerTypeTranslation }

  constructor(
    id: string,
    translations: { [locale: string]: LockerTypeTranslation },
  ) {
    this.id = id
    this.translations = translations
  }

  findTranslationByLocale(locale: Locales): LockerTypeTranslation | null {
    return this.translations[locale] ?? null
  }

  translate(locale: Locales, fallbackLocale: Locales) {
    let translation = this.findTranslationByLocale(locale)

    if (!translation) {
      translation = this.findTranslationByLocale(fallbackLocale)
    }

    return translation
  }

  static fromJson(data: LockerTypeJson) {
    return new this(
      data.id,
      data.translations.reduce(
        (previous, current) => ({
          ...previous,
          [current.locale]: LockerTypeTranslation.fromJson(current),
        }),
        {},
      ),
    )
  }

  toJson(): LockerTypeJson {
    return {
      id: this.id,
      translations: Object.values(this.translations).map((t) => t.toJson()),
    }
  }
}
